var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTubeDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    stroke: "none",
    d: "M31.8 15.2001C31.8 15.2001 31.6 13.5001 30.8 12.8001C29.9 11.8001 28.9 11.8001 28.4 11.8001C25 11.6001 20 11.6001 20 11.6001C20 11.6001 15 11.6001 11.6 11.8001C11.1 11.9001 10.1 11.9001 9.2 12.8001C8.5 13.5001 8.2 15.2001 8.2 15.2001C8.2 15.2001 8 17.1001 8 19.1001V20.9001C8 22.8001 8.2 24.8001 8.2 24.8001C8.2 24.8001 8.4 26.5001 9.2 27.2001C10.1 28.2001 11.3 28.1001 11.8 28.2001C13.7 28.4001 20 28.4001 20 28.4001C20 28.4001 25 28.4001 28.4 28.1001C28.9 28.0001 29.9 28.0001 30.8 27.1001C31.5 26.4001 31.8 24.7001 31.8 24.7001C31.8 24.7001 32 22.8001 32 20.8001V19.0001C32 17.1001 31.8 15.2001 31.8 15.2001ZM17.5 23.1001V16.4001L24 19.8001L17.5 23.1001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeDefault);
export default __webpack_public_path__ + "static/media/YouTube_Default.9e20210b.svg";
export { ForwardRef as ReactComponent };